import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "gamify.status.icon",
  "use": "gamify.status.icon-usage",
  "viewBox": "-610 1349 125 107.549",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-610 1349 125 107.549\" id=\"gamify.status.icon\"><defs><style>#gamify.status.icon .b{fill:#2699fb}</style></defs><g stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\"><path stroke=\"none\" d=\"M0 0H125V107.549H0z\" transform=\"translate(-610 1349)\" /><path d=\"M1 1H124V106.549H1z\" transform=\"translate(-610 1349)\" /></g><path class=\"b\" d=\"M105.216,82.4V93.638a29.118,29.118,0,0,1,16.733,26.546,29.469,29.469,0,1,1-58.938,0A29.131,29.131,0,0,1,79.745,93.638V82.4a39.86,39.86,0,1,0,25.471,0Z\" transform=\"translate(-639.599 1287.275)\" /><path class=\"b\" transform=\"translate(-552.769 1359.139)\" d=\"M0 0H11.321V41.543H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gamify.status.icon.svg
// module id = Jf82
// module chunks = 13